import type { Bundle } from '../types'

/** Usurpation de marques : domaines, apps, réseaux sociaux, SMS, pages de paiement. */
export const discovery = {
  // Onglets
  'discovery.tab.all': { fr: 'Tout', en: 'All' },
  'discovery.tab.domains': { fr: 'Domaines', en: 'Domains' },
  'discovery.tab.apps': { fr: 'Apps', en: 'Apps' },
  'discovery.tab.social': { fr: 'Sociaux', en: 'Social' },
  'discovery.tab.sms': { fr: 'SMS', en: 'SMS' },
  'discovery.tab.payments': { fr: 'Paiements', en: 'Payments' },

  // Sources
  'discovery.source.CRT_SH': { fr: 'Certificat SSL', en: 'SSL certificate' },
  'discovery.source.APP_STORE': { fr: 'App Store', en: 'App store' },
  'discovery.source.SOCIAL': { fr: 'Réseaux sociaux', en: 'Social media' },
  'discovery.source.SMISHING': { fr: 'SMS frauduleux', en: 'Fraudulent SMS' },
  'discovery.source.DNS_MONITOR': { fr: 'Surveillance DNS', en: 'DNS monitoring' },
  'discovery.source.SEARCH_ENGINE': { fr: 'Moteur de recherche', en: 'Search engine' },
  'discovery.source.PAYMENT_INTEGRATION': { fr: 'Page de paiement', en: 'Payment page' },

  // Barre de scan
  'discovery.runScan': { fr: 'Lancer un scan :', en: 'Run a scan:' },
  'discovery.scan.domains': { fr: 'Domaines SSL', en: 'SSL domains' },
  'discovery.scan.apps': { fr: 'App stores', en: 'App stores' },
  'discovery.scan.social': { fr: 'Réseaux sociaux', en: 'Social media' },
  'discovery.scan.payments': { fr: 'Paiements', en: 'Payments' },
  'discovery.scanRunning': { fr: 'Scan en cours…', en: 'Scan in progress…' },
  'discovery.scanStart': { fr: 'Lancer le scan {label}', en: 'Run the {label} scan' },
  'discovery.scanDomainsResult': {
    fr: '{total} domaine(s) trouvé(s), {saved} enregistré(s)',
    en: '{total} domain(s) found, {saved} saved',
  },
  'discovery.scanAppsResult': {
    fr: '{total} app(s) suspecte(s) trouvée(s), {saved} enregistrée(s)',
    en: '{total} suspicious app(s) found, {saved} saved',
  },
  'discovery.scanSocialResult': {
    fr: '{total} compte(s) suspect(s) trouvé(s), {saved} enregistré(s)',
    en: '{total} suspicious account(s) found, {saved} saved',
  },
  'discovery.scanPaymentsResult': {
    fr: '{total} intégration(s) détectée(s), {undeclared} non déclarée(s)',
    en: '{total} integration(s) detected, {undeclared} undeclared',
  },
  'discovery.scanError': { fr: 'Erreur : {error}', en: 'Error: {error}' },

  // Filtres
  'discovery.allLevels': { fr: 'Tous niveaux', en: 'All levels' },
  'discovery.allStatuses': { fr: 'Tous statuts', en: 'All statuses' },
  'discovery.emptySms': {
    fr: 'Aucun signalement SMS. Les signalements arrivent par POST /reports/smishing.',
    en: 'No SMS report yet. Reports arrive via POST /reports/smishing.',
  },
  'discovery.empty': { fr: 'Aucun élément détecté pour ce filtre', en: 'Nothing detected for this filter' },

  // Fiche domaine / app / compte
  'discovery.brandLabel': { fr: 'Marque :', en: 'Brand:' },
  'discovery.active': { fr: 'Actif', en: 'Active' },
  'discovery.inactive': { fr: 'Inactif', en: 'Inactive' },
  'discovery.devPrefix': { fr: 'Dév. :', en: 'Dev:' },
  'discovery.viewSource': { fr: 'Voir la source ↗', en: 'View source ↗' },
  'discovery.viewPost': { fr: 'Voir le post sur {platform} ↗', en: 'View the post on {platform} ↗' },
  'discovery.via': { fr: 'via {source}', en: 'via {source}' },
  'discovery.similarity': { fr: 'Similarité : {score}/100', en: 'Similarity: {score}/100' },
  'discovery.screenshot': { fr: 'Capture', en: 'Screenshot' },

  // Fiche SMS
  'discovery.sms.sender': { fr: 'Expéditeur :', en: 'Sender:' },
  'discovery.sms.spoofed': { fr: '⚠ Usurpé ({brand})', en: '⚠ Spoofed ({brand})' },
  'discovery.sms.classification': { fr: 'Classification :', en: 'Classification:' },
  'discovery.sms.score': { fr: 'Score : {score}/100', en: 'Score: {score}/100' },
  'discovery.sms.countryLabel': { fr: 'Pays : {country}', en: 'Country: {country}' },
  'discovery.sms.extractedUrls': { fr: 'URLs extraites :', en: 'Extracted URLs:' },
  'discovery.sms.reportedOn': { fr: 'Signalé le {date}', en: 'Reported on {date}' },
  'discovery.sms.correlate': { fr: 'Corréler', en: 'Correlate' },
  'discovery.sms.noUrl': { fr: 'Aucune URL dans ce SMS.', en: 'No URL in this SMS.' },
  'discovery.sms.correlationFound': {
    fr: 'Corrélation trouvée : « {host} » correspond au domaine suspect « {domain} » ({brand}, {level})',
    en: 'Correlation found: “{host}” matches the suspicious domain “{domain}” ({brand}, {level})',
  },
  'discovery.sms.correlationNone': {
    fr: 'Aucune corrélation trouvée pour « {host} » parmi les domaines suspects.',
    en: 'No correlation found for “{host}” among the suspicious domains.',
  },
  'discovery.sms.correlationError': { fr: 'Erreur lors de la corrélation.', en: 'Correlation failed.' },
  'discovery.sms.class.PAYMENT_SCAM': { fr: 'Arnaque au paiement', en: 'Payment scam' },
  'discovery.sms.class.ACCOUNT_VERIFY': { fr: 'Vérification de compte', en: 'Account verification' },
  'discovery.sms.class.PRIZE_SCAM': { fr: 'Arnaque au gain', en: 'Prize scam' },
  'discovery.sms.class.URGENT_ACTION': { fr: 'Action urgente', en: 'Urgent action' },
  'discovery.sms.class.MALWARE_LINK': { fr: 'Lien malveillant', en: 'Malware link' },
  'discovery.sms.class.UNKNOWN': { fr: 'Non classifié', en: 'Unclassified' },
  'discovery.sms.status.PENDING': { fr: 'En attente', en: 'Pending' },
  'discovery.sms.status.CONFIRMED_SMISHING': { fr: 'Confirmé', en: 'Confirmed' },
  'discovery.sms.status.FALSE_POSITIVE': { fr: 'Faux positif', en: 'False positive' },
  'discovery.sms.status.ESCALATED': { fr: 'Escaladé', en: 'Escalated' },

  // Fiche page de paiement
  'discovery.pay.badge': { fr: 'Paiement', en: 'Payment' },
  'discovery.pay.module': { fr: 'Module :', en: 'Module:' },
  'discovery.pay.risk': { fr: 'Risque : {score}/100', en: 'Risk: {score}/100' },
  'discovery.pay.signatures': { fr: 'Signatures détectées', en: 'Signatures detected' },
  'discovery.pay.actionLabel': { fr: 'Action : {action}', en: 'Action: {action}' },
  'discovery.pay.compliance.COMPLIANT': { fr: 'Conforme', en: 'Compliant' },
  'discovery.pay.compliance.NON_COMPLIANT': { fr: 'Non conforme', en: 'Non-compliant' },
  'discovery.pay.compliance.UNDECLARED': { fr: 'Non déclaré', en: 'Undeclared' },
  'discovery.pay.compliance.PENDING_REVIEW': { fr: 'En révision', en: 'Under review' },
  'discovery.pay.match.KNOWN_MERCHANT': { fr: 'Marchand connu', en: 'Known merchant' },
  'discovery.pay.match.UNDECLARED': { fr: 'Marchand inconnu', en: 'Unknown merchant' },
  'discovery.pay.match.PARTIAL_MATCH': { fr: 'Correspondance partielle', en: 'Partial match' },
  'discovery.pay.action.CLEAR': { fr: 'Rien à faire', en: 'No action' },
  'discovery.pay.action.INVESTIGATE': { fr: 'Investiguer', en: 'Investigate' },
  'discovery.pay.action.ONBOARD': { fr: 'Proposer un contrat', en: 'Offer onboarding' },
  'discovery.pay.action.BLOCK': { fr: 'Bloquer', en: 'Block' },
  'discovery.pay.action.TAKEDOWN': { fr: 'Retirer', en: 'Take down' },
} satisfies Bundle
